import { EvaluationProps, RatingWrapper } from "./GroupedEvaluation";
import Rating from "@mui/material/Rating";
import useRatingLabels from "./useRatingLabels";

const StarsEvaluation = (props: EvaluationProps) => {
    const { subTitleId, ratingProps } = useRatingLabels({
        maxValue: props.maxValue,
        isLocked: props.isLocked,
    });

    return (
        <RatingWrapper>
            <h2 id={subTitleId}>{props.subTitle}</h2>
            <Rating
                {...ratingProps}
                value={Number(props.answers[props.index]?.answer)}
                max={props.maxValue}
                precision={props.useDecimal ? 0.5 : 1}
                readOnly={props.isLocked}
                onChange={(e: React.SyntheticEvent, newValue: number | null) =>
                    props.onRateChange(e, newValue, props.id, props.index)
                }
            />
        </RatingWrapper>
    );
};

export default StarsEvaluation;
